import { render, staticRenderFns } from "./ressetcode.vue?vue&type=template&id=10cae6dd&scoped=true&"
import script from "./ressetcode.vue?vue&type=script&lang=js&"
export * from "./ressetcode.vue?vue&type=script&lang=js&"
import style0 from "./ressetcode.vue?vue&type=style&index=0&id=10cae6dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cae6dd",
  null
  
)

export default component.exports